<template>
    <div class="alert-box" :class="[$mq]">
            <div class="content-container">
                <div class="title-message">
                    <div class="icon" :class="status">
                        <i v-if="status == 'issues'" class="i-andy-exclamation i-andy-ml"></i>
                        <i v-if="status == 'turned-off'" class="i-andy-bell-disabled i-andy-ml"></i>
                        <i v-if="status == 'alerts'" class="i-andy-menu-task i-andy-ml"></i>
                        <i v-if="status == 'inactive'" class="i-andy-no-wifi i-andy-ml"></i>
                    </div>
                    <div class="title">
                        <div class="title-content" v-html="$tc(title)"></div>
                        <div class="subtitle">{{ num_alerts }}</div>
                    </div>
                </div>
                <div class="description" v-html="$tc(description)"></div>
                <div class="optional-link" v-if="link != undefined">
                    <router-link class="text" :to="getLinkWithKpi">{{ $t(linkText) }}</router-link>
                    <i class="i-andy-right-arrow i-andy-s"></i>
                </div>
            </div>
    </div>
</template>

<script>
export default {
    name: 'AlertBox',
    props: {
        title: String,
        description: String,
        num_alerts: [Number,Boolean],
        link: String,
        linkText: String,
        status: String
    },
    computed: {
        getLinkWithKpi() {
            if (this.link === 'sensor' && this.status) {
                const statusToKpi = {
                    'alerts': 'alerts',
                    'turned-off': 'offline',
                    'inactive': 'disconnected',
                    'issues': 'issues'
                }
                const kpiType = statusToKpi[this.status]
                if (kpiType) {
                    return {
                        name: 'Sensor',
                        query: { kpi: kpiType }
                    }
                }
            }
            return this.link
        }
    }
}
</script>

<style lang="scss" scoped>
.alert-box {
    background-color: $color-white;
    border-radius: 4px;
    width: 460px;
    height: 200px;

    @media (min-width: 900px) and (max-width: 1050px) {
        width: 400px;
        height: 200px;
    }
    .content-container {
        @include display-flex();
        flex-direction: column;
        @include justify-content(space-between);
        width: 100%;
        height: 100%;
        padding: 16px;

        .title-message {
            @include display-flex();
            align-items: center;
            gap: 12px;

            .icon {
                @include display-flex();
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                width: 44px;
                height: 44px;
                padding: 4px;

                &.issues, &.inactive {
                    background-color: $error-t90;

                    i {
                        color: $error-dark;
                    }
                }
                &.turned-off {
                    background-color: $neutro-t80;

                    i {
                        color: $neutro-s30;
                    }
                }
                &.alerts {
                    background-color: $color-warning-100;

                    i {
                        color: $color-warning-500;
                    }
                }
            }

            .title {
                .title-content {
                    @include font-size(ml);
                    padding-bottom: 4px;
                }
                .subtitle {
                    @include font-size(l);
                    font-family: $text-bold;
                }
            }
        }

        .description {
            @include font-size(ml);
            padding: 0;
            margin: 0;
        }

        .optional-link {
            @include font-size(m);
            color: $color-secondary-500;
            padding: 4px;
            i {
                color: $color-secondary-500;
                padding-left: 4px;
            }
            .text {
                font-family: $text-bold;
            }
        }
    } 
}
</style>
<style lang="scss" scoped>
// PORTRAIT
.portrait {
    background-color: $color-white !important;
    border-radius: 4px !important;
    width: 90% !important;
    height: 250px !important;
}
</style>